
/**
 * Rcont
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Konva from 'konva'

export default class Rcont extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'entryPoint',
        x: 0,
        y: 0,
        width: 25,
        height: 25,
        strokeWidth: 0.5,
        fill: 'white',
        text: '',
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'entry',
        x: 3,
        y: 5,
        width: 20,
        text: '',
        fontSize: 14,
        align: 'center',
        fill: 'black'
      }),

      new Ren.Rect({
        name: 'exitPoint',
        x: 100,
        y: 0,
        width: 25,
        height: 25,
        strokeWidth: 0.5,
        fill: 'white',
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'exit',
        x: 103,
        y: 5,
        width: 20,
        text: '',
        fontSize: 14,
        align: 'center',
        fill: 'black'
      })
    )
  }

  setContact (status, position) {
    if (status[position] === undefined) {
      this.modifyShape(position, 'text', '')
    } else if (status[position] === 0) {
      this.modifyShape(`${position}Point`, 'fill', 'red')
      this.modifyShape(position, 'text', '+')
    } else if (status[position] === 1) {
      this.modifyShape(`${position}Point`, 'fill', 'blue')
      this.modifyShape(position, 'text', '-')
    } else {
      this.modifyShape(`${position}Point`, 'fill', 'white')
      this.modifyShape(position, 'text', '')
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    // if status.entry === 0 -> +
    // if status.entry === 1 -> -

    // if status.exit === 0 -> +
    // if status.exit === 1 -> -

    this.setContact(status, 'entry')
    this.setContact(status, 'exit')
  }
}
